var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import 'rxjs/add/operator/takeUntil';
import { Subject } from 'rxjs';
import { ReservationService } from '@app/reservation/reservation.service';
import moment from 'moment';
moment.locale('de');
import { resStatus } from '@app/core/constants';
import { takeUntil } from 'rxjs/operators';
export class AddTimeFilterComponent {
    constructor(activeModal, formBuilder, snackBar, reservationService) {
        this.activeModal = activeModal;
        this.formBuilder = formBuilder;
        this.snackBar = snackBar;
        this.reservationService = reservationService;
        this.shiftData = [];
        this.roomData = [];
        this.tagData = [];
        this.allStatusData = [];
        this.passEntry = new EventEmitter();
        this.ngUnsubscribe = new Subject();
        this.allStatus = resStatus;
        this.tablesData = [];
        this.rooms = [];
        this.shifts = [];
        this.allTags = [];
        this.isLoading = false;
    }
    ngOnInit() {
        this.loadFilter();
        this.resTimeFilterFormGroup = this.formBuilder.group({
            name: ['', Validators.required],
            from: ['', Validators.required],
            to: ['', Validators.required],
            roomIds: [null],
            shiftId: [null],
            tagIds: [null],
            status: [null]
        });
    }
    loadFilter() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isLoading = true;
            try {
                this.allStatus = this.allStatusData || resStatus;
                const tagPromise = this.tagData && this.tagData.length ? Promise.resolve(this.tagData) : this.getAllTags();
                const shiftPromise = this.shiftData && this.shiftData.length ? Promise.resolve(this.shiftData) : this.getShifts();
                const roomPromise = this.roomData && this.roomData.length ? Promise.resolve(this.roomData) : this.getRooms();
                const [tags, shifts, rooms] = yield Promise.all([tagPromise, shiftPromise, roomPromise]);
                this.allTags = tags;
                this.shifts = shifts;
                this.rooms = rooms;
                if (this.editTimeFilterData) {
                    let timeFrom = this.editTimeFilterData.from.split(':');
                    this.time1 = {
                        hour: parseInt(timeFrom[0]),
                        minute: parseInt(timeFrom[1]),
                        second: 0
                    };
                    let timeTo = this.editTimeFilterData.to.split(':');
                    this.time2 = {
                        hour: parseInt(timeTo[0]),
                        minute: parseInt(timeTo[1]),
                        second: 0
                    };
                    this.resTimeFilterFormGroup.addControl('id', new FormControl(this.editTimeFilterData.id, Validators.required));
                    this.resTimeFilterFormGroup.get('from').setValue(this.time1);
                    this.resTimeFilterFormGroup.get('to').setValue(this.time2);
                    this.resTimeFilterFormGroup.get('name').setValue(this.editTimeFilterData.name);
                    this.resTimeFilterFormGroup.get('status').setValue(this.editTimeFilterData.status || null);
                    const editTagIds = this.parseIdCsv(this.editTimeFilterData.tagIds);
                    const editTagObjects = editTagIds
                        .map((id) => this.allTags.find((t) => Number(t.id) === id))
                        .filter((t) => !!t);
                    this.resTimeFilterFormGroup.get('tagIds').setValue(editTagObjects.length ? editTagObjects : null);
                    const editRoomIds = this.parseIdCsv(this.editTimeFilterData.roomIds);
                    this.resTimeFilterFormGroup.get('roomIds').setValue(editRoomIds.length ? editRoomIds : null);
                    this.resTimeFilterFormGroup.get('shiftId').setValue(this.editTimeFilterData.shiftId || null);
                }
            }
            finally {
                this.isLoading = false;
            }
        });
    }
    getRooms() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.reservationService.getRooms(false).toPromise();
            if (!data) {
                return [];
            }
            const rooms = [...data];
            const allTables = [];
            rooms.forEach((room) => {
                allTables.push(...room.tables);
            });
            const allRooms = Object.assign({}, rooms[0], { id: 1000, name: 'All', tables: allTables });
            rooms.push(allRooms);
            // Assign state (optional)
            this.rooms = rooms;
            this.tablesData = rooms.length ? rooms[0].tables : [];
            return rooms;
        });
    }
    getShifts() {
        return __awaiter(this, void 0, void 0, function* () {
            const shifts = yield this.reservationService
                .getShifts()
                .pipe(takeUntil(this.ngUnsubscribe))
                .toPromise();
            this.shifts = shifts;
            if (this.editTimeFilterData) {
                this.resTimeFilterFormGroup.get('shiftId').setValue(this.editTimeFilterData.shiftId || null);
            }
            return shifts;
        });
    }
    getAllTags() {
        return __awaiter(this, void 0, void 0, function* () {
            const tags = yield this.reservationService
                .getTags()
                .pipe(takeUntil(this.ngUnsubscribe))
                .toPromise();
            this.allTags = tags;
            return tags;
        });
    }
    parseIdCsv(value) {
        if (value == null || value === '') {
            return [];
        }
        const raw = Array.isArray(value) ? value : String(value).split(',');
        return raw
            .map((v) => (v && typeof v === 'object' ? v.id : v))
            .map((v) => Number(v))
            .filter((v) => !Number.isNaN(v));
    }
    toIdCsv(value) {
        const ids = this.parseIdCsv(value);
        return ids.length ? ids.join(',') : null;
    }
    add() {
        if (!this.resTimeFilterFormGroup.valid) {
            this.snackBar.open('Bitte überprüfen Sie Ihre Angaben.', '', {
                duration: 2000,
                panelClass: ['snackbar-error']
            });
            return;
        }
        const payload = Object.assign({}, this.resTimeFilterFormGroup.value);
        payload.from = `${String(payload.from.hour).padStart(2, '0')}:${String(payload.from.minute).padStart(2, '0')}`;
        payload.to = `${String(payload.to.hour).padStart(2, '0')}:${String(payload.to.minute).padStart(2, '0')}`;
        payload.tagIds = this.toIdCsv(payload.tagIds);
        payload.roomIds = this.toIdCsv(payload.roomIds);
        this.passEntry.emit(payload);
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
